import { Component, OnInit } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { FormValidatorService } from '../../shared/form_Validation/form-validator.service';
import { ApiService } from '../../services/api.service';
import { reCaptchaSiteKey } from 'src/app/config';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/services/auth-service.service';

@Component({
  selector: 'app-twofactor-login',
  templateUrl: './twofactor-login.component.html',
  styleUrls: ['./twofactor-login.component.css']
})
export class TwofactorLoginComponent implements OnInit {
  Two_fact_code;
  year = new Date().getFullYear();
  action: string;
  constructor(private route: ActivatedRoute
    , private router: Router
    , private authService: AuthService
    , private Formvalidator: FormValidatorService
    , private formBuilder: FormBuilder
    , private Register: ApiService
    , private cookieService: CookieService) {

    this.Two_fact_code = this.formBuilder.group({
      Code: new FormControl('', [Validators.required]),
    });
  }
  submitAuthData() {
    if (this.Two_fact_code.valid) {
      const data = {
        token: (this.Two_fact_code.get('Code').value).toString(),
        where: 'login'
      };
      this.Register.functionPOST('user/verifyTwofa', data).subscribe((res) => {
          this.cookieService.set('token', res['data']['token'], 0, '/',
            null,
            null, 'Lax');
        this.Register.openSnackBar('Success', 'Success');
        if (res['data']['agreementNotification']) {
          if (this.action) {
            this.router.navigate(['/terms-and-conditions'], {queryParams: {'action': this.action}});
          } else {
            this.router.navigate(['/terms-and-conditions']);
          }
        } else {
          if (res['data']['expireNotification']) {
            localStorage.setItem('expiry', res['data']['expireNotification_message']);
          }
          if (res['data']['isRestrictedUser']) {
            this.router.navigate(['/current_business/profile']);
            return;
          }
          if (res['data']['no_allowedBusinesses'] === 0) {
            if (this.action === 'passwordReset') {
              this.router.navigate(['/current_business/Security_Settings']);
            } else {
            this.router.navigate(['/current_business']);
            }
            return;
          }
          if (res['data']['no_allowedBusinesses'] !== 0) {
            // this.getExpiry();
            // if (res['data']['expireNotification']) {
            //   localStorage.setItem('expiry', res['data']['expireNotification_message']);
            // }
            if (this.action === 'passwordReset') {
              this.router.navigate(['/dashboard/Security_Settings']);
            } else {
            this.router.navigate(['/dashboard/task-management']);
            }
          }
        }
      },
        err => {

          this.Register.openSnackBar(err['error'], 'Error');
          this.Two_fact_code.reset();
        });
    }
  }
  ngOnInit() {
    sessionStorage.removeItem('token');
    this.getActionByUrl();
  }
  getActionByUrl() {
    this.route.queryParamMap.subscribe(paramsdata => {
      const action = paramsdata['params']['action'];

      if (action) {
        this.action = action;
        switch (action) {
          case 'passwordReset':
            break;
          default:
            break;
        }
      }
    });
  }
  logOut() {
    this.Register.functionPOST('admin/logout', {}).subscribe((res) => {
      this.authService.logout();
    });
  }
}
